
<template>
  <v-card class="pa-0 ma-0" flat>
    <v-autocomplete
      v-model="item"
      :items="items"
      item-text="search_text"
      :label="label"
      return-object
      v-on:change="selectAction"
      :rules="rules"
      v-on:update:search-input="searchItems"
      :loading="loading_inv_items"
      persistent-hint
    >
      <!-- <template v-slot:[`item.item-name`]="{}"></template> -->
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>{{data.item[name_key]}}</v-list-item-title>
            <v-list-item-subtitle>SKU {{data.item.sku}}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="data.item.barcode && data.item.barcode.length>0">
              Barcode
              <span v-for="(barcode, ind) in data.item.barcode" :key="ind">{{barcode+', '}}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
      <template #no-data>
        <slot name="nodata"></slot>
      </template>
    </v-autocomplete>
  </v-card>
</template>

<script>
export default {
  name: "v-search-items",
  props: {
    label: String,
    items: Array,
    value: Object,
    selectedAct: Function,
    searchItems: {
      type: Function,
      default: () => {}
    },
    loading_inv_items: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => [],
    },
    name_key: {
      type: String,
      default: 'product_name'
    }
  },
  data: () => ({
    item: null,
  }),
  mounted() {
    if (this.value) this.item = this.value;
  },
  methods: {
    selectAction() {
      const item = this.item;
      this.item = {
        product_name: "",
      };
      this.selectedAct(item);
    },
  },
};
</script>
